export default ['😁', '😝', '😎', '😉']